import { container } from '@shared/common/dependency-injection/domain/container';
import { useCurrentClientUserStore } from '@client/entity/current-client-user/application/store/current-client-user.store';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserSelectionService } from '@client/entity/current-client-user/domain/service/current-client-user-selection.service';

let mainLayoutInitPromise: Promise<void> | null = null;

export async function checkClientSelected(): Promise<boolean> {
  const currentClientUserStore = useCurrentClientUserStore();
  if (currentClientUserStore.selectedClient) {
    return true;
  }

  // Ensure main layout client selection is initialized when landing directly on the SPA route
  // or when the user reloads the page (so clientInfos may be empty).
  if (!mainLayoutInitPromise) {
    mainLayoutInitPromise = (async () => {
      const clientSelectionService = container.get<CurrentClientUserSelectionService>(
        CurrentClientUserDependencyTypes.CurrentClientUserSelectionService,
      );
      clientSelectionService.ensureSelectedClient();
    })().finally(() => {
      mainLayoutInitPromise = null;
    });
  }

  await mainLayoutInitPromise;
  return true;
}
